module.exports = __webpack_public_path__ + "436539da95e575a2c4c78c697c46a84d.svg";